import {Card} from 'primereact/card';
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {Redirect} from 'react-router-dom';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import {CustomMessages} from '../components/CustomMessages';
import SimpleReactValidator from '../components/validator';
import AuthService from '../services/AuthService';
import RegistrationService from '../services/RegistrationService';
import AccountService from '../services/AccountService';
import CompanyService from '../services/CompanyService';
import AppPrefixUtils from '../utils/AppPrefixUtils';
import BlockUi from './../components/waitPanel/BlockUi';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import CurrencyUtils from '../utils/CurrencyUtils';
import SettingService from '../services/SettingService';
import i18n from '../i18n';
import { Dialog } from 'primereact/dialog';

class LoginContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.demoMode = process.env.REACT_APP_DEMO_MODE === "true";
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.registrationService = new RegistrationService();
        this.handleTokenMessage = this.handleTokenMessage(props.confirmToken);
        this.login = this.login.bind(this);
        this.authService = new AuthService();
        this.userService = new AccountService();
        this.companyService = new CompanyService();
        this.settingService = new SettingService();
        this.state = {
            blocking: false,
            email: this.demoMode ? 'demo@primigenius.pl' : '',
            password: this.demoMode ? 'demo' : '',
            redirectToReferrer: false,
            authValid: true,
            showCaptcha: false,
            captchaPreventAction: false,
            requiresTwoFactor: false,
            twoFactorUsername: '',
            twoFactorPassword: '',
            twoFactorMessage: '',
            twoFactorCode: '',
        };
        this.handleVerifyTwoFactor = this.handleVerifyTwoFactor.bind(this);
        this.handleTwoFactorDigitChange = this.handleTwoFactorDigitChange.bind(this);
        this.handleTwoFactorDigitKeyDown = this.handleTwoFactorDigitKeyDown.bind(this);
        this.handleTwoFactorPaste = this.handleTwoFactorPaste.bind(this);
        this.authValidValidator = new SimpleReactValidator(
            {
                validators: {
                    auth: {
                        // name the rule
                        message: ':attribute',
                        rule: (val, params, validator) => {
                            return this.state.authValid;
                        }, // optional
                        required: true,
                    },
                },
            },
            props.t
        );
    }

    handleTokenMessage(confirmToken) {
        if (confirmToken !== undefined) {
            let href = AppPrefixUtils.locationHrefUrl(window.location.href);
            var token = href.substring(href.indexOf('=') + 1);

            this.registrationService
                .getTokenInformation(token)
                .then((response) => {
                    this.showSuccessMessage('Witamy w systemie!');
                })
                .catch((err) => {
                    if (err.message === undefined || err.message == null || err.message === '') {
                        this.showSuccessMessage('Witamy w systemie!');
                    } else {
                        this.showErrorMessage(err.message, 10000, true, 'Błąd ');
                    }
                });
        }
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    getContainerListName() {
        return 'login-container';
    }
    componentDidMount() {
        super.componentDidMount();
        this.readMessage();
    }

    readMessage() {
        const messageFromStorage = this.readCookie(this.getContainerListName());
        if (messageFromStorage !== undefined && messageFromStorage != null) {
            const message = JSON.parse(messageFromStorage);
            this.removeCookie(this.getContainerListName());
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }

    handleFormSubmit(e) {
        if (e !== undefined) {
            e.preventDefault();
        }
        let username = this.state.email;

        if (this.validator.allValid()) {
            this.authService
                ?.getIp()
                ?.then((ip) => {
                    sessionStorage.setItem('ip', ip);
                    this.login(username, this.state.password, ip);
                    this.blockUi();
                })
                .catch(() => {
                    console.log('ip adress is not available on this browser');
                    sessionStorage.setItem('ip', '');
                    this.login(username, this.state.password, '');
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    login(userName, password, ip) {
        this.authService
            .login(userName, password, undefined, ip)
            .then((res) => {
                if (res.requiresTwoFactor) {
                    this.unblockUi();
                    this.setState({
                        requiresTwoFactor: true,
                        twoFactorUsername: res.username || userName,
                        twoFactorPassword: password,
                        twoFactorMessage: res.message || this.props.t('login.two_factor_message'),
                    });
                    return;
                }
                this.continueAfterLogin(res);
            })
            .catch((err) => {
                console.log('err', err);
                if (err.status === 401 || err.status === 403) {
                    this.showErrorMessage('Błąd logowania', 10000, true, 'Błąd ');
                } else {
                    this.showErrorMessage(err.message);
                }
                this.unblockUi();
            });
    }

    continueAfterLogin(res) {
        const locale = this.authService.getLanguageFromToken(res.token);
        sessionStorage.setItem('i18nextLng', locale);
        i18n.changeLanguage(locale, () => {
            this.companyService
                .get()
                .then((company) => {
                    const missingLogo = !company?.logoUuid;
                    const missingLocations = !Array.isArray(company?.locations) || company.locations.length === 0;
                    if (missingLogo || missingLocations) {
                        this.targetLocation = '/company/setup';
                    } else {
                        this.targetLocation = undefined;
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.unblockUi();
                    if (this.props.onAfterLogin) {
                        this.props.onAfterLogin();
                    }
                    const path = this.targetLocation ? this.targetLocation : '/dashboard';
                    try {
                        this.props.history.replace(AppPrefixUtils.locationHrefUrl(path));
                    } catch (e) {}
                    this.setState({ redirectToReferrer: true });
                });
        });
    }

    handleTwoFactorDigitChange(index, e) {
        const val = e.target.value.replace(/\D/g, '').slice(-1);
        const prev = this.state.twoFactorCode || '';
        const next = (prev.slice(0, index) + val + prev.slice(index + 1)).slice(0, 6);
        this.setState({ twoFactorCode: next }, () => {
            if (val && index < 5) this[`twoFactorDigit${index + 1}`]?.focus();
        });
    }

    handleTwoFactorDigitKeyDown(index, e) {
        if (e.key === 'Backspace' && !this.state.twoFactorCode?.[index] && index > 0) {
            e.preventDefault();
            const prev = this.state.twoFactorCode || '';
            this.setState({ twoFactorCode: prev.slice(0, index - 1) + prev.slice(index) });
            this[`twoFactorDigit${index - 1}`]?.focus();
        }
    }

    handleTwoFactorPaste(e) {
        e.preventDefault();
        const pasted = (e.clipboardData?.getData('text') || '').replace(/\D/g, '').slice(0, 6);
        this.setState({ twoFactorCode: pasted });
        const nextIdx = Math.min(pasted.length, 5);
        setTimeout(() => this[`twoFactorDigit${nextIdx}`]?.focus(), 0);
    }

    handleVerifyTwoFactor(e) {
        if (e !== undefined) e.preventDefault();
        const { twoFactorUsername, twoFactorPassword, twoFactorCode } = this.state;
        if (!twoFactorCode || !twoFactorCode.trim()) {
            this.showErrorMessage(this.props.t('login.two_factor_code_required'));
            return;
        }
        this.blockUi();
        this.authService
            .verifyTwoFactor(twoFactorUsername, twoFactorPassword, twoFactorCode.trim())
            .then((res) => this.continueAfterLogin(res))
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(err?.message || this.props.t('login.two_factor_error'));
            });
    }

    async downloadApp() {        
        if (this.demoMode) {            
            try {
                const response = await fetch('/static/app-release.apk', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                });
            
                if (!response.ok) {
                throw new Error('Network response was not ok');
                }
            
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'app-release.apk';
                document.body.appendChild(a);
                a.click();
                a.remove();
            } catch (error) {
                console.error('Error downloading the file:', error);
            }
        }
    }

    render() {
        if (this.authService.loggedIn()) {
            return this.renderAfterAuth();
        } else {
            return this.renderBeforeAuth();
        }
    }

    renderAfterAuth() {
        const {redirectToReferrer} = this.state;
        if (redirectToReferrer === true) {
            return <Redirect to={this.targetLocation ? this.targetLocation : '/dashboard'} />;
        }
        // Czekamy na decyzję dokąd przekierować po sprawdzeniu firmy
        return <div></div>;
    }

    renderTwoFactorForm(t) {
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main-login'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        <div className='login-background-container'>
                            <Card className='details-card'>
                                <form
                                    className='login-container'
                                    onSubmit={(e) => this.handleVerifyTwoFactor(e)}
                                    onKeyDown={(e) => e.key === 'Enter' && this.handleVerifyTwoFactor(e)}
                                    noValidate
                                >
                                    <div id='logo'>
                                        <img
                                            className='card-icon'
                                            style={{maxWidth: '150px'}}
                                            alt=''
                                            src={AppPrefixUtils.locationHrefUrl(`/images/logo.svg`)}
                                        />
                                    </div>
                                    <div className='login-form-container mt-2'>
                                        <p className='login-label mb-2' style={{whiteSpace: 'nowrap'}}>{this.state.twoFactorMessage}</p>
                                        <div className='login-label'>{t('login.two_factor_code')}</div>
                                        <div className='d-flex justify-content-center gap-2 my-3' style={{gap: '0.5rem'}}>
                                            {[0, 1, 2, 3, 4, 5].map((i) => (
                                                <input
                                                    key={i}
                                                    ref={(el) => (this[`twoFactorDigit${i}`] = el)}
                                                    autoFocus={i === 0}
                                                    type='text'
                                                    inputMode='numeric'
                                                    maxLength={6}
                                                    aria-label={`${t('login.two_factor_code')} ${i + 1}`}
                                                    className='form-control text-center'
                                                    style={{width: '2.5rem', fontSize: '1.25rem'}}
                                                    value={(this.state.twoFactorCode || '')[i] || ''}
                                                    onChange={(e) => this.handleTwoFactorDigitChange(i, e)}
                                                    onKeyDown={(e) => this.handleTwoFactorDigitKeyDown(i, e)}
                                                    onPaste={(e) => this.handleTwoFactorPaste(e)}
                                                    autoComplete='one-time-code'
                                                />
                                            ))}
                                        </div>
                                        <div className='row login-links mt-3'>
                                            <ActionLink
                                                label={t('login.two_factor_back')}
                                                variant='forgot-password-button'
                                                handleClick={() => this.setState({
                                                    requiresTwoFactor: false,
                                                    twoFactorUsername: '',
                                                    twoFactorPassword: '',
                                                    twoFactorMessage: '',
                                                    twoFactorCode: '',
                                                })}
                                            />
                                        </div>
                                        <div className='mb-30'></div>
                                        <ActionButton
                                            id='verifyTwoFactorButton'
                                            label={t('login.two_factor_verify')}
                                            variant='login-button all-width-button'
                                            handleClick={() => this.handleVerifyTwoFactor()}
                                        />
                                    </div>
                                </form>
                            </Card>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }

    renderBeforeAuth() {
        const {t} = this.props;
        if (this.state.requiresTwoFactor) {
            return this.renderTwoFactorForm(t);
        }
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main-login'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        <div className='login-background-container'>
                            <Card className='details-card'>
                                <form
                                    className='login-container'
                                    onSubmit={(e) => {
                                        if (!this.state.captchaPreventAction) {
                                            this.handleFormSubmit(e);
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            if (!this.state.captchaPreventAction) {
                                                this.handleFormSubmit();
                                            }
                                        }
                                    }}
                                    noValidate
                                >
                                    <div id='logo'>
                                        <img
                                            className='card-icon'
                                            style={{maxWidth: '150px'}}
                                            alt=''
                                            src={AppPrefixUtils.locationHrefUrl(`/images/logo.svg`)}
                                        />
                                    </div>
                                    <div className='login-form-container mt-2'>
                                        <div className='login-label'>{t('login.form.userName')}</div>
                                        <div location='user_field'>
                                            <InputText
                                                className='login-input'
                                                aria-label={t('login.form.userName')}
                                                key={'email'}
                                                id={'email'}
                                                name={'email'}
                                                placeholder={''}
                                                style={{width: '100%'}}
                                                value={this.state.email}
                                                onChange={(e) => this.handleChange('TEXT', undefined, e, undefined, '')}
                                                required={true}
                                                validator={this.validator}
                                                validators='required|max:50'
                                            />
                                            <div aria-live='assertive' className='login-form-validation'>
                                                {this.validator.message('email', t('login.form.userName'), this.state.email, 'required')}
                                            </div>
                                            <div className='login-label'>{t('login.form.password')}</div>
                                            <div location='pass_field'>
                                                <Password
                                                    inputClassName='login-input'
                                                    aria-label={t('login.form.password')}
                                                    key={'password'}
                                                    inputId={'password'}
                                                    name={'password'}
                                                    placeholder={''}
                                                    toggleMask={true}
                                                    inputStyle={{width: '100%'}}
                                                    style={{width: '100%'}}
                                                    value={this.state.password}
                                                    onChange={(e) => this.handleChange('TEXT', undefined, e, undefined, '')}
                                                    promptLabel={t('login.form.password')}
                                                    feedback={false}
                                                    required={true}
                                                    validator={this.authValidValidator}
                                                    validators='not_required'
                                                />
                                                <div aria-live='assertive' className='login-form-validation'>
                                                    {this.validator.message(
                                                        'password',
                                                        t('login.form.password'),
                                                        this.state.password,
                                                        'required'
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row login-links'>
                                            <ActionLink
                                                label={t('login.forget-password')}
                                                variant='forgot-password-button '
                                                href={AppPrefixUtils.locationHrefUrl('/forgot-password')}
                                            />
                                        </div>
                                        <div className='mb-30'></div>
                                        <ActionButton
                                            id='loginButton'
                                            label={t('login.form.login')}
                                            variant='login-button all-width-button'
                                            handleClick={this.handleFormSubmit}
                                            disabled={this.state.captchaPreventAction}
                                        />
                                    </div>
                                    {this.demoMode ? (
                            <div className='row'>
                                <div className='col-md-12' style={{textAlign: 'right'}}>
                                    <ActionLink 
                                        label="Pobierz aplikację mobilną"
                                        variant='forgot-password-button'
                                        handleClick={() => this.setState({showAppDownloadDialog: true})}
                                    />
                                </div>
                            </div>) : null }

                            {this.demoMode ? (
                            <Dialog
                                ariaCloseIconLabel={t('dialog.closeDialog')}
                                header="Pobierz aplikację mobilną Amanda!"
                                visible={this.state.showAppDownloadDialog}
                                resizable={false}
                                key="app-download-dialog"
                                onHide={() => this.setState({showAppDownloadDialog: false})}
                                closable={this.state.closable}
                            >
                                <Card footer={this.renderFooter()}>
                                    <form noValidate onKeyDown={(e) => this.onKeyDown(e)}>
                                        <span>
                                        Aplikacja mobilna <b>Amanda Demo</b> dostępna jest dla systemu Android. 
                                        <br/>Kliknij poniżej, aby pobrać plik APK i zainstalować aplikację na swoim urządzeniu.
                                        <ul style={{'padding-left': '30px'} }>
                                            <li>Upewnij się, że masz włączoną opcję instalacji aplikacji z nieznanych źródeł w ustawieniach swojego telefonu.</li>
                                            <li>Po pobraniu otwórz plik APK, aby rozpocząć instalację.</li>
                                        </ul>

                                        Do logowania użyj następujących danych, dostępne konta od 1 do 5 np:
                                        <ul style={{'padding-left': '30px'} }>
                                            <li>Adres e-mail: <b>demo1@primigenius.pl</b></li>
                                            <li>Hasło: <b>demo1</b></li>
                                        </ul> 
                                        </span>
                                        <ActionLink 
                                            label="Pobierz aplikację mobilną"
                                            handleClick={() => this.downloadApp()}
                                        />

                                    </form>
                                </Card>
                            </Dialog>) : null}
                                </form>
                            </Card>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}
LoginContainer.propTypes = {
    onAfterLogin: PropTypes.func,
};

export default withRouter(withTranslation()(LoginContainer));
